import React from "react";
import { Typography, Box } from "@mui/material";
import { COLORS } from "constants/colors";
import StyledButton from "default/components/StyledButton";

function PayPayConfirm({ onConfirm }) {
  const [isDisabled, setIsDisabled] = React.useState(false);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        minHeight: "100vh",
      }}
    >
      <Box
        sx={{
          width: "90%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: COLORS.BACKGROUND_WHITE,
          borderRadius: "5px",
          padding: 4,
          gap: 4,
        }}
      >
        <Box>
          <Typography
            sx={(theme) => ({
              fontSize: "16px",
              whiteSpace: "pre-line",
              fontWeight: "bold",
              textAlign: "center",
              color: "#EB8010", // 落ち着いたオレンジ文字
              backgroundColor: "#FFF9EE", // 薄オレンジ背景
              border: "1px solid #FFD591", // 枠線もやさしめ
              borderRadius: "6px",
              padding: "10px 14px",
              lineHeight: "1.6",
              mt: 1,
            })}
          >
            PayPay決済が完了しても、LINEに戻るまでPayPayアプリを閉じずにそのままお待ちください。
          </Typography>
        </Box>

        <StyledButton
          variant="contained"
          sx={{
            width: "50%",
            fontSize: "17px",
            color: COLORS.TEXT_BLACK,
            border: `2px solid ${COLORS.TEXT_BLACK}`,
          }}
          onClick={onConfirm}
          disabled={isDisabled}
        >
          購入する
        </StyledButton>
      </Box>
      {/* <ButtonDialog
        open={openError}
        title={"エラー"}
        description={
          "決済処理でエラーが発生しました。運営までお問い合わせください。"
        }
        handleClose={() => setOpenError(false)}
      /> */}
    </Box>
  );
}

export default PayPayConfirm;
